<template>
    <div class="wrapper-form-input-caixadeselecao">
        <div class="control">
            <TrfDraggable pKeyAttribute="uuidEditor" :pAllowDropAround="false" :pItems="opcoes" :pGroupName="'cadastro-opcoes-checkbox'" :pUseCustomHandler="true" pCustomHandlerClass="drag-checkbox-handle" style="max-width:700px;width:100%;" @changed:items="setItems">
              <template #item="{item, index}">
                <div class="drag-caixadeselecao-wrapper columns">
                    <a class="button is-white drag-checkbox-handle drag-handle-body px-0"><span class="mdi mdi-drag drag-checkbox-handle pt-2"></span></a>
                    <div class="campo columns column" :class="{'has-error': !item.label}">
                        <label class="checkbox column is-narrow px-0" inert>
                            <input type="checkbox" :value="item.label" :name="item.label" />
                        </label>
                        <TrfToolbarTextEditorInline
                            class="column py-0"
                            :id="item.uuidEditor"
                            :defaultText="getTitulo(item)"
                            @changeText="($event, ref$) => setValue($event, index, ref$, item)"
                            :is-obrigatorio="true"
                            tag="p"
                            :editorStyle="`.wrapper-form-input-caixadeselecao p.mce-content-body { width: 100%; background:#FFF; font-size: 1rem!important; color: #666!important; padding: .25rem .75rem; border-bottom: 1px solid #33333300; transition: border 0.35s ease-in-out 0s} p.mce-content-body:focus-visible, p.mce-content-body:hover { outline: 0 none; border-bottom: 1px solid ${estilosPadrao.CorPrimaria}FF}`"
                            :maxlength="100"
                            :ref="`label${index}`"
                            :toolbar-options="''"
                        ></TrfToolbarTextEditorInline>
                        <a @click="deleteOption(item, index)" class="button is-white px-0 pt-3 pb-0 column is-narrow btn-delete"><span class="mdi mdi-close pt-1"></span></a>
                    </div>
                </div>
              </template>
            </TrfDraggable>
            <p v-if="!hasOptions && !hasOpcaoOutro" class="has-error mb-4 ml-5 pl-4">É necessário cadastrar ao menos uma opção.</p>
            <div v-if="hasOpcaoOutro" class="outros columns pl-1">
                <label class="checkbox column is-narrow" inert>
                    <input type="checkbox" name="Outros..." />
                </label>
                <p class="column">Outros...</p>
                <a @click="deleteOutros" class="button is-white px-0 pt-3 pb-0 column is-narrow btn-delete"><span class="mdi mdi-close pt-1"></span></a>
            </div>
            <div class="drag-caixadeselecao-wrapper columns pl-1">
                <label class="checkbox column is-narrow" inert>
                    <input inert type="checkbox" name="resposta" />
                </label>
                <p class="column">
                    <template v-if="!hasOpcaoOutro">
                        <span>
                            <span tabindex="0" @click="adicionarOpcao" @keypress.enter="adicionarOpcao">Adicionar opção</span> ou <a tabindex="0" @click="adicionarOutro" @keypress.enter="adicionarOutro">adicionar "Outro"</a>
                        </span>
                    </template>
                    <template v-else>
                        <span>
                            <span tabindex="0" @click="adicionarOpcao" @keypress.enter="adicionarOpcao">Adicionar opção</span>
                        </span>
                    </template>
                </p>
            </div>
        </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  import { stylesUtils } from '../../../util/styles.utils';
  import { gerarGUID } from '../../../util/uuid.utils';

  const DEFAULT_OPTIONS = [
        {
            ordem: 1,
            label: "Opção 1",
            labelHtml: "Opção 1",
            uuidEditor: gerarGUID()
        }
    ]

  export default {
    name: 'TrfCaixaDeSelecao',
    emits: ['update:value', 'update:opcoes'],
    components: {
        TrfToolbarTextEditorInline: defineAsyncComponent(() => import('../../ToolbarTextEditor/inline.vue')),
        TrfDraggable: defineAsyncComponent(() => import('../../Draggable/index.vue'))
    },
    props: {
        pHasOpcaoOutro: {
            type: Boolean,
            default: false
        },
        pOpcoes: {
            type: Array,
            default: () => Object.assign([], DEFAULT_OPTIONS)
        },
        hasOptions: {
            type: Boolean,
            default: true
        }
    },
    data() {
      return {
        estilosPadrao: '',
        value: '',
        hasOpcaoOutro: this.pHasOpcaoOutro,
        opcoes: this.pOpcoes
      };
    },
    computed: {
    },
    methods: {
        getTitulo(item) {
            const labelFallback = item.label? item.label : `Opção ${item.ordem}`
            return item.labelHtml? item.labelHtml : labelFallback
        },
        async setValue(value, index, ref, item) {
            const opcaoIndex = this.opcoes.findIndex(opcao => opcao.uuidEditor == item.uuidEditor);
            if (opcaoIndex < 0) return '';
            const opcaoAtualizada = {
                ...this.opcoes[opcaoIndex],
                labelHtml: value,
                label: ref.getValueAsText()
            }
            this.opcoes[opcaoIndex] = opcaoAtualizada
            await this.$nextTick()
            this.emitOpcoes(this.opcoes)
        },
        async setItems(items) {
            if (!this.opcoes || !Array.isArray(items)) return [];
            items.forEach((item, index) => {
                item.ordem = index+1
            })
            this.opcoes = items
            await this.$nextTick()
            this.updateOptionsLabels()
        },
        updateOptionsLabels() {
            this.opcoes.forEach((item, index) => {
                if (!item.uuidEditor || !this.$refs[item.uuidEditor]) return;
                item.label = this.$refs[item.uuidEditor].iniciarTextEditorComValor(item.labelHtml)
            })
            this.emitOpcoes(this.opcoes)
        },
        emitValue(value) {
            this.$emit('update:value', value)
        },
        emitOpcoes(opcoes) {
            this.$emit('update:opcoes', opcoes, this.hasOpcaoOutro)
        },
        adicionarOpcao() {
            const opcaoDeclarada = {
                ordem: this.opcoes.length + 1,
                label: `Opção ${this.opcoes.length + 1}`,
                labelHtml: `Opção ${this.opcoes.length + 1}`,
                uuidEditor: gerarGUID()
            }
            this.opcoes.push(opcaoDeclarada)
            this.emitOpcoes(this.opcoes)
        },
        adicionarOutro() {
            this.hasOpcaoOutro = true
            this.emitOpcoes(this.opcoes)
        },
        deleteOption(item, itmIndex) {
            const opcoesLimpas = this.opcoes.filter((opcao, index) => {
                if (!opcao.uuidEditor && !item.uuidEditor) {
                    return itmIndex != index
                }
                return opcao.uuidEditor != item.uuidEditor
            })
            this.setItems(opcoesLimpas)
        },
        deleteOutros() {
            this.hasOpcaoOutro = false;
            this.emitOpcoes(this.opcoes);
        }
    },
    mounted() {
        this.estilosPadrao = stylesUtils.adquirirEstilosCookie();
        this.emitOpcoes(this.opcoes)
    }
  };
  </script>
  <style lang="scss" scoped>
  .has-error {
    color:#a94442FF;
  }
  .wrapper-form-input-caixadeselecao {
    .outros > p {
        border-bottom: 1px dotted #666;
        color: #666;
        opacity: 0.75;
        cursor: default;
        pointer-events: none;
    }
      @media screen and (max-width: 768px) {
          .drag-caixadeselecao-wrapper, .outros {
              display:flex;
              label, .btn-delete {
                flex: 0 0 auto;
              }
              .campo {
                  display:flex;
                  .radio {
                      flex-grow:0;
                  }
              }
          }
      }
  }
 </style>
 <style lang="scss">
 .wrapper-form-input-caixadeselecao .drag-caixadeselecao-wrapper .campo.has-error .mce-content-body {
     border-bottom-color: #a94442FF!important;
 }
 </style>